<template>
  <div class="home_container">
    <div class="header_box">
      <!-- <div class="initiate_box">
        <div class="initiate_single initiate" @click="initiationSingle">
          <div class="col1">
            <img src="../../../assets/images/index/icon1.png" alt="" />
            <span class="label">快速发起业务</span>
          </div>
          <div class="info">填写任务信息并发起赋强</div>
        </div>
        <div class="initiate_batch initiate" @click="initiationBatch">
          <div class="col1">
            <img src="../../../assets/images/index/icon2.png" alt="" />
            <span class="label">批量发起业务</span>
          </div>
          <div class="info">通过文件模板批量发起赋强</div>
        </div>
      </div> -->
      <div class="block2">
        <img src="../../../assets/images/index/block1.png" alt="" />
        <div class="num">{{ statistic.launchNum || 0 }}</div>
        <div class="label">已发起业务</div>
      </div>
      <div class="block3">
        <div class="box">
          <div class="num">{{ statistic.launchTodayNum || 0 }}</div>
          <div class="label">今日发起业务</div>
        </div>
        <div class="box">
          <div class="num">{{ statistic.launchMonthNum || 0 }}</div>
          <div class="label">本月发起小计</div>
        </div>
      </div>
      <div class="block2">
        <img src="../../../assets/images/index/block2.png" alt="" />
        <div class="num">{{ statistic.applicationNum || 0 }}</div>
        <div class="label">办理中业务</div>
      </div>
      <div class="block2">
        <img src="../../../assets/images/index/block3.png" alt="" />
        <div class="num">{{ statistic.reviewNum || 0 }}</div>
        <div class="label">审核中业务</div>
      </div>
      <div class="block2">
        <img src="../../../assets/images/index/block5.png" alt="" />
        <div class="num">{{ statistic.abnormalBusinessNum || 0 }}</div>
        <div class="label">新增异常业务</div>
      </div>

      <div class="block2">
        <img src="../../../assets/images/index/block4.png" alt="" />
        <div class="num">{{ statistic.certifiedNum || 0 }}</div>
        <div class="label">已出证业务</div>
      </div>
      <div class="block3">
        <div class="box">
          <div class="num">{{ statistic.certifiedTodayNum || 0 }}</div>
          <div class="label">今日出证业务</div>
        </div>
        <div class="box">
          <div class="num">{{ statistic.certifiedMonthNum || 0 }}</div>
          <div class="label">本月出证小计</div>
        </div>
      </div>
    </div>
    <div class="table myTable">
      <div class="item">
        <div class="label">
          <div class="line"></div>
          <div class="titleLabel">我发起的</div>
          <div class="more" @click="toMore">查看更多 <i class="el-icon-arrow-right"></i></div>
        </div>
        <div class="useBox">
          <!-- 最大化 -->
          <img
            @click="initiatedMeMaximize('hand')"
            src="../../../assets/images/index/userIcon1.png"
            alt=""
          />
          <!-- 最小化 -->
          <img
            @click="initiatedMeMinimize('hand')"
            src="../../../assets/images/index/userIcon2.png"
            alt=""
          />
          <!-- 还原 -->
          <img
            @click="initiatedMeDefaul('hand')"
            src="../../../assets/images/index/userIcon3.png"
            alt=""
          />
        </div>
      </div>
      <el-table
        size="small"
        :data="initiatedMeList"
        :class="initiatedMeShow ? 'table-height' : 'table-height-0'"
        :header-row-style="{background: '#F8F8F8'}"
        :header-cell-style="{background: '#F8F8F8'}"
      >
        <el-table-column type="index" label="序号" width="67">
        </el-table-column>
        <el-table-column prop="name" label="合同名称" show-overflow-tooltip min-width="150">
        </el-table-column>
        <el-table-column prop="code" label="合同编号" show-overflow-tooltip width="150">
        </el-table-column>
        <el-table-column prop="signStatus" label="业务状态" min-width="150">
          <template slot-scope="scope">
            <div>{{ signStatusMap[scope.row.signStatus] }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="contractUser.name"
          label="发起方"
          min-width="150"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="debtorName" label="参与方" show-overflow-tooltip width="150">
        </el-table-column>
        <el-table-column prop="businessDynamics" label="业务动态" show-overflow-tooltip width="150">
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" min-width="150">
        </el-table-column>
        <el-table-column prop="signStartTime" label="发起时间" min-width="150">
        </el-table-column>
        <el-table-column prop="date" label="操作" min-width="115" fixed="right">
          <template slot-scope="scope">
            <div class="handlerBoxCenter">
              <div class="cursorPointer" @click="toDetail(scope.row)">
                <span class="iconDscp">详情</span>
              </div>
              <div class="cursorPointer tip" v-if="scope.row.signStatus === 1 && !scope.row.waitingMeSign" @click="tipPerson(scope.row)">
                <!-- <span class="icon"></span> -->
                <span class="iconDscp">提醒</span>
              </div>
              <div class="cursorPointer" v-if="scope.row.signStatus === 1 && scope.row.waitingMeSign" @click="toSignTrue(scope.row, '1')">
                <span class="iconDscp">签署</span>
              </div>
              <div
                class="cursorPointer revoke"
                v-if="judgeShowRevoke(scope.row)"
                @click="revokeContract(scope.row)"
              >
                <span class="iconDscp">撤销</span>
              </div>
              <div class="cursorPointer" @click="downLoad(scope.row)" v-if="scope.row.signStatus === 5">
                <span class="iconDscp">下载公证书</span>
              </div>
              <!-- <div
              class="cursorPointer "
              v-if="judgeShowReject(scope.row)"
              @click="toReject(scope.row,'1')"
            >
              <span class="iconDscp">拒签</span>
            </div>
            <div class="cursorPointer " @click="toDetail(scope.row)">
              <span class="iconDscp">详情</span>
            </div> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="table waitTable">
      <div class="item">
        <div class="label">
          <div class="line"></div>
          <div class="titleLabel">待我签署 （共{{ waitMeTotal }}条）</div>
          <div class="more" @click="toMore(1)">查看更多 <i class="el-icon-arrow-right"></i></div>
        </div>
        <div class="useBox">
          <!-- 最大化 -->
          <img
            @click="waitMeMaximize('hand')"
            src="../../../assets/images/index/userIcon1.png"
            alt=""
          />
          <!-- 最小化 -->
          <img
            @click="waitMeMinimize('hand')"
            src="../../../assets/images/index/userIcon2.png"
            alt=""
          />
          <!-- 还原 -->
          <img
            @click="waitMeDefaul('hand')"
            src="../../../assets/images/index/userIcon3.png"
            alt=""
          />
        </div>
      </div>
      <el-table
        size="small"
        :data="waitMeList"
        :class="waitMeShow ? 'table-height' : 'table-height-0'"
        :header-row-style="{background: '#F8F8F8'}"
        :header-cell-style="{background: '#F8F8F8'}"
      >
        <el-table-column type="index" label="序号" width="67">
        </el-table-column>
        <el-table-column prop="name" label="合同名称" show-overflow-tooltip min-width="150">
        </el-table-column>
        <el-table-column prop="code" label="合同编号" show-overflow-tooltip width="150">
        </el-table-column>
        <el-table-column prop="signStatus" label="业务状态" min-width="150">
          <template slot-scope="scope">
            <div>{{ signStatusMap[scope.row.signStatus] }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="contractUser.name"
          label="发起方"
          min-width="150"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="debtorName" label="参与方" show-overflow-tooltip width="150">
        </el-table-column>
        <el-table-column prop="businessDynamics" label="业务动态" show-overflow-tooltip width="150">
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" min-width="150">
        </el-table-column>
        <el-table-column prop="signStartTime" label="发起时间" min-width="150">
        </el-table-column>
        <el-table-column prop="date" label="操作" width="115" fixed="right">
          <template slot-scope="scope">
            <div class="handlerBoxCenter">
              <div class="cursorPointer" @click="toDetail(scope.row)">
                <span class="iconDscp">详情</span>
              </div>
              <div class="cursorPointer" v-if="scope.row.signStatus === 1" @click="toSignTrue(scope.row, '1')">
                <span class="iconDscp">签署</span>
              </div>
              <div
                class="cursorPointer revoke"
                v-if="judgeShowRevoke(scope.row)"
                @click="revokeContract(scope.row)"
              >
                <span class="iconDscp">撤销</span>
              </div>
              <!-- <div
                class="cursorPointer"
                v-if="judgeShowReject(scope.row)"
                @click="toReject(scope.row, '1')"
              >
                <span class="iconDscp">拒签</span>
              </div> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <Dialog
      :visible="authDialogShow"
      :dialogTitle="'消息提示'"
      :width="'400px'"
      @closeDialog="authDialogShow = false"
    >
      <div class="signDialog" slot="dialog">
        <div class="authDscp">
          <p>您还没有通过实名认证，</p>
          <p>无法发起签约，请去实名认证！</p>
        </div>
        <div class="authHandlerBox">
          <div class="button cursorPointer" @click="authDialogShow = false">
            取消
          </div>
          <div
            class="button buttonActive cursorPointer"
            @click="$router.push('/personal/users/home')"
          >
            去认证
          </div>
        </div>
      </div>
    </Dialog>

    <reject-sign-dialog
      v-if="rejectDialogShow"
      @closeDialog="rejectDialogShow = false"
      :taskId="rejectParams.taskId"
      :contractId="rejectParams.contractId"
      @restDetail="restDetail"
    ></reject-sign-dialog>

    <Dialog
      :visible="revokeDialoglShow"
      :dialogTitle="'撤销合同'"
      :width="'400px'"
      @closeDialog="revokeDialoglShow = false"
    >
      <div class="signDetailDialogWithButton" slot="dialog">
        <div class="authDscp">
          <p>是否要撤销这份合同？</p>
          <p>撤销完成后，服务费将在1-3个工作日，</p>
          <p>退回到您的账户，请注意查收！</p>
        </div>
        <div class="authHandlerBox">
          <div
            class="button buttonActive cursorPointer"
            @click="revokeDialoglShow = false"
          >
            取消
          </div>
          <div class="button cursorPointer" @click="revoke">确定</div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import BaseApi from "@lib/baseApi.js";
import { mapGetters, mapState } from "vuex";
// import RejectSignDialog from "./components/initiateContract/RejectSign.vue";
import RejectSignDialog from "@/components/personal/sign/components/initiateContract/RejectSign.vue";
import Dialog from "@common/Dialog.vue";
import download from "@lib/download.js";
import storageUtil from "@lib/storageUtil.js";
export default {
  name: "",
  props: {},

  components: {
    RejectSignDialog,
    Dialog,
  },

  data() {
    return {
      waitMeList: [],
      contractIdS: "",
      authDialogShow: false,
      waitMeTotal: 0,
      waitMeParams: {
        listFlag: "waitSign",
        pageSize: 5,
        pageNumber: 1,
        status: 1,
        withStat: false
      },
      waitMeShow: true, // 是否显示待我签署

      initiatedMeList: [],
      initiatedMeTotal: 0,
      initiatedMeParams: {
        listFlag: "waitSign",
        pageSize: 5,
        pageNumber: 1,
        status: 8,
        withStat: false
      },
      initiatedMeShow: true, // 是否显示我发起的列表

      rejectDialogShow: false,

      // 统计数据
      statistic: {},

      queryConfig: {},

      // 撤销数据
      revokeParams: {},
      revokeDialoglShow: false,

      signStatusMap: {
        "0": "未发起",
        "1": "签署中",
        "2": "签署完成",
        "3": "终止",
        "4": "拒签",
        "5": "已公证",
      },
    };
  },

  async created() {
    await this.getQueryConfig();
    this.getHomeStatistics();
    this.getList("waitSign");
    this.getList("initiated");
  },

  computed: {
    ...mapGetters(["getUserInfo"]),
    ...mapState(["currentInfo"]),
    changeIdentity() {
      const roleCode = this.currentInfo.roleId || this.currentInfo.id;
      return roleCode;
    },
  },
  methods: {
    // 待我签署 最大化
    waitMeMaximize(hand) {
      this.waitMeParams.pageSize = 10;
      this.waitMeShow = true;
      this.getList("waitSign");
      this.saveQueryConfig("1", {
        pageSize: 10,
        show: "1",
      });
      if (hand) {
        this.initiatedMeMinimize();
      }
    },
    // 待我签署 最小化
    waitMeMinimize(hand) {
      this.waitMeShow = false;
      let pageSize = 5;
      if (this.queryConfig["1"] && this.queryConfig["1"].pageSize) {
        pageSize = this.queryConfig["1"].pageSize;
      }
      this.saveQueryConfig("1", {
        pageSize: pageSize,
        show: this.waitMeShow ? "1" : "0",
      });
      if (hand) {
        this.initiatedMeMaximize();
      }
    },
    // 待我签署 还原
    waitMeDefaul(hand) {
      this.waitMeParams.pageSize = 5;
      this.waitMeShow = true;
      this.getList("waitSign");
      this.saveQueryConfig("1", {
        pageSize: 5,
        show: "1",
      });
      if (hand) {
        this.initiatedMeDefaul();
      }
    },

    // 待我签  我发起的 列表
    getList(listFlag) {
      // listFlag: "waitSign",
      this.$store.commit("showLoading", true);
      let params = this.waitMeParams;
      if (listFlag === "initiated") {
        params = this.initiatedMeParams;
      }
      BaseApi.createRpcToken("/contract/v2/list", params)
        .then(
          (data) => {
            this.$store.commit("showLoading", false);
            if (data.datas) {
              if (listFlag === "waitSign") {
                this.waitMeList = data.datas.list.list;
                this.waitMeTotal = data.datas.list.totalRow || 0;
                console.log(this.waitMeList, "this.waitMeList");
              } else if (listFlag === "initiated") {
                this.initiatedMeList = data.datas.list.list;
                this.initiatedMeTotal = data.datas.list.totalRow || 0;
              }
            }
          },
          () => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },

    // 我发起的 最大化
    initiatedMeMaximize(hand) {
      this.initiatedMeParams.pageSize = 10;
      this.initiatedMeShow = true;
      this.getList("initiated");
      this.saveQueryConfig("8", {
        pageSize: 10,
        show: "1",
      });
      if (hand) {
        this.waitMeMinimize();
      }
    },
    // 我发起的 最小化
    initiatedMeMinimize(hand) {
      this.initiatedMeShow = false;
      let pageSize = 5;
      if (this.queryConfig["8"] && this.queryConfig["8"].pageSize) {
        pageSize = this.queryConfig["8"].pageSize;
      }
      this.saveQueryConfig("8", {
        pageSize: pageSize,
        show: this.initiatedMeShow ? "1" : "0",
      });
      if (hand) {
        this.waitMeMaximize();
      }
    },
    // 我发起的 还原
    initiatedMeDefaul(hand) {
      this.initiatedMeShow = true;
      this.initiatedMeParams.pageSize = 5;
      this.getList("initiated");
      this.saveQueryConfig("8", {
        pageSize: 5,
        show: "1",
      });
      if (hand) {
        this.waitMeDefaul();
      }
    },

    getUserInfos() {
      return BaseApi.createRpcToken("/user/v2/getUserInfo");
    },
    //获取该合同支付状态
    getContractInfo() {
      return BaseApi.createRpcToken(
        "/contract/info",
        { id: this.contractIdS },
        "post"
      );
    },
    getTaskId(data, flag, all) {
      if (!data || !data.length) {
        return "";
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i].actionCode === flag) {
          if (all) {
            return data[i];
          } else {
            return data[i].taskId;
          }
        }
      }
    },
    async toSignTrue(data) {
      this.$store.commit("showLoading", true);
      try {
        let userInfo = await this.getUserInfos();
        let curInfo = {};
        userInfo = [
          ...[userInfo.datas.person],
          ...userInfo.datas.enterpriseList,
        ];
        curInfo = userInfo.filter(
          (item) => item.userId == this.currentInfo.userId
        )[0];
        if (!curInfo.success || curInfo.authenticationStatus != 2) {
          this.authDialogShow = true;
          this.$store.commit("showLoading", false);
        } else {
          let temp = encodeURI(JSON.stringify(data));
          let taskId = this.getTaskId(data.taskList, "SIGN");
          let isCanReject = 1;
          if (data.contractUser.userId == this.currentInfo.userId) {
            isCanReject = 0;
          }
          this.contractIdS = data.id;

          // 判断是否已经支付过
          this.getContractInfo().then(
            (resData) => {
              this.$store.commit("showLoading", false);
              if (resData.datas.info.payStatus == 0) {
                //未支付，去支付
                this.$router.push({
                  path: "/personal/payment",
                  query: {
                    id: this.contractIdS,
                    flag: "Sign",
                    taskId: taskId,
                    isCanReject: isCanReject,
                    isHandwriting: false,
                    type: data.type,
                  },
                });
              } else {
                //已支付，去签署,1-普通合同；2-赋强合同,4-调解赋强签署
                if (data.type == 1) {
                  this.$router.push(
                    `/personal/sign/index/signature?isHandwriting=false&id=${this.contractIdS}&taskId=${taskId}&isCanReject=${isCanReject}`
                  );
                } else if (data.type == 2) {
                  this.$router.push(
                    `/personal/sign/signLoanIndex?isHandwriting=false&id=${this.contractIdS}&taskId=${taskId}&isCanReject=${isCanReject}`
                  );
                } else {
                  this.$router.push(
                    `/personal/sign/signMediate?isHandwriting=false&id=${this.contractIdS}&taskId=${taskId}&isCanReject=${isCanReject}`
                  );
                }
              }
            },
            () => {}
          );
        }
      } catch (e) {
        errorLog(e);
      }
    },

    judgeShowRevoke(row) {
      return this.getTaskId(row.taskList, "REVOKE");
    },

    judgeShowReject(row) {
      let SignTask = this.getTaskId(row.taskList, "SIGN", true);
      if (SignTask) {
        if (row.contractUser.userId == SignTask.userId) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    toReject(row) {
      let taskId = this.getTaskId(row.taskList, "SIGN");
      let contractId = row.id;
      this.rejectParams = { taskId, contractId };
      this.rejectDialogShow = true;
    },
    // 撤销
    revokeContract(row) {
      let taskId = this.getTaskId(row.taskList, "REVOKE");
      let contractId = row.id;
      this.revokeParams = { taskId, contractId };
      this.revokeDialoglShow = true;
      console.log(this.revokeDialoglShow, "revokeDialoglShow");
    },
    revoke() {
      this.$store.commit("showLoading", true);
      this.revokeDialoglShow = false;
      let locationInfo = this.$store.getters.getLocation;
      BaseApi.createRpcToken(
        "/contract/revoke",
        {
          id: this.revokeParams.contractId,
          taskId: this.revokeParams.taskId,
          signLocation: locationInfo && locationInfo.location,
          signLocationAttr: locationInfo && locationInfo.LocationAttr,
        },
        "post"
      )
        .then((data) => {
          this.$store.commit("showLoading", false);
          if (data.datas.success) {
            this.$message.success("撤销成功");
            this.restDetail();
          } else {
            this.$message.error("撤销失败");
          }
        })
        .catch(function (e) {
          this.$store.commit("showLoading", false);
          errorLog(e);
        });
    },

    // 提醒
    tipPerson(row) {
      BaseApi.createRpcToken("/contract/remind", {
        id: row.id,
      })
        .then((data) => {
          if (data.datas.success) {
            this.$message.success("已发送提醒");
            this.activeChange();
          } else {
            this.$message.error("提醒发送失败");
          }
        })
        .catch(function (e) {
          errorLog(e);
        });
    },

    // 下载公证书 
    downLoad(item) {
      if (!item.certificateDataRightId) {
        this.$message.error("暂未生成公证书");
        return;
      }
      BaseApi.createRpcToken(
        "/notaryApply/downloadDataRight",
        {
          rightId: item.certificateDataRightId,
        },
        "GET"
      ).then((res) => {
        if (res.code == 200) {
          this.loading = false;

          var elemIF = document.createElement("iframe");
          elemIF.src = res.datas.path;
          elemIF.style.display = "none";
          elemIF.setAttribute("id", "startDown");
          if (document.getElementById("startDown")) {
            document.body.removeChild(document.getElementById("startDown"));
          }
          document.body.appendChild(elemIF);
        } 
        // else if (res.code == 20001) {
        //   this.loading = true;
        //   // var that = this
        //   if (item.queryCount < 4) {
        //     console.log(item.queryCount);
        //     setTimeout(() => {
        //       item.queryCount++;
        //       console.log(item.queryCount);
        //       this.downLoad(item);
        //     }, 2000);
        //   }
           else {
            // item.queryCount = 0;
            // this.loading = false;
            this.$message.error(res.message);
          }
        // }
      });
    },

    toDetail(row) {
      this.$router.push(`/personal/sign/detail?id=${row.id}`);
    },
    restDetail() {
      this.getHomeStatistics();
      this.getList("waitSign");
      this.getList("initiated");
    },

    // 快速发起
    initiationSingle() {
      this.$router.push("/initiation/single");
    },
    initiationBatch() {
      this.$router.push("/initiation/batch");
    },

    // 首页-统计
    getHomeStatistics() {
      this.$store.commit("showLoading", true);
      BaseApi.createRpcToken("/contract/v2/homeStatistics")
        .then(
          (data) => {
            this.$store.commit("showLoading", false);
            if (data.code === 200 && data.datas.statistic) {
              this.statistic = data.datas.statistic;
            }
          },
          () => {}
        )
        .catch(function (e) {
          this.$store.commit("showLoading", false);
        });
    },

    // 列表查询配置
    async getQueryConfig() {
      await BaseApi.createRpcToken("/contract/v2/queryConfig")
        .then(
          (data) => {
            if (data.code === 200) {
              let queryConfig = data.datas.queryConfig;
              if (queryConfig) {
                queryConfig = JSON.parse(queryConfig);
                this.queryConfig = queryConfig;
                if (queryConfig["1"]) {
                  // 待我签署
                  this.waitMeParams.pageSize = queryConfig["1"]["pageSize"];
                  if (queryConfig["1"]["show"]) {
                    if (queryConfig["1"]["show"] === "1") {
                      this.waitMeShow = true;
                    } else {
                      this.waitMeShow = false;
                    }
                  }
                }
                if (queryConfig["8"]) {
                  // 待我签署
                  this.initiatedMeParams.pageSize =
                    queryConfig["8"]["pageSize"];
                  if (queryConfig["8"]["show"]) {
                    if (queryConfig["8"]["show"] === "1") {
                      this.initiatedMeShow = true;
                    } else {
                      this.initiatedMeShow = false;
                    }
                  }
                }
              }
            }
          },
          () => {}
        )
        .catch(function (e) {});
    },
    // 保存配置
    saveQueryConfig(type, data) {
      let queryConfig = this.queryConfig;
      console.log(data, "data");
      const { pageSize = 5, show = "1" } = data;
      console.log(queryConfig);
      if (!queryConfig[type]) {
        queryConfig[type] = {
          pageSize: pageSize,
          show: show,
        };
      } else {
        queryConfig[type].pageSize = pageSize;
        queryConfig[type].show = show;
      }
      console.log(queryConfig, "querconfig");
      BaseApi.createRpcToken(
        "/contract/v2/updateQueryConfig",
        {
          queryConfig: JSON.stringify(queryConfig),
        },
        "post"
      )
        .then(
          (data) => {
            if (data.code === 200) {
            }
          },
          () => {}
        )
        .catch(function (e) {});
    },

    // 查看更多
    toMore(status) {
      if (status === 1) { // 待我签署
        storageUtil.setSession("signHomeCurrentListFlag", "waitSign");
      } else {
        storageUtil.setSession("signHomeCurrentListFlag", "allContract");
      }
      this.$router.push("/personal/sign/home");
    }
  },
};
</script>

<style scoped lang="scss">
.home_container {
  padding: 25px 24px;
  height: 100%;
  box-sizing: border-box;
  .header_box {
    height: 156px;
    background-color: #f8f8f8;
    padding: 12px;
    display: flex;
    margin-bottom: 24px;
    .initiate_box {
      margin-right: 32px;
      cursor: pointer;
      .initiate {
        width: 236px;
        height: 72px;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .label {
          font-size: 16px;
          color: #ffffff;
          line-height: 24px;
        }
        .info {
          font-size: 14px;
          color: #ffffff;
          line-height: 24px;
        }
        .col1 {
          display: flex;
          align-items: center;
          img {
            margin-right: 8px;
          }
        }
      }
      .initiate_single {
        margin-bottom: 12px;
        background: linear-gradient(
          131deg,
          rgba(233, 58, 51, 0.8) 0%,
          #d81212 100%
        );
      }
      .initiate_batch {
        background: linear-gradient(
          131deg,
          rgba(241, 132, 127, 0.62) 0%,
          #ec605a 100%
        );
      }
    }
    .block2 {
      flex: 1;
      background-color: #ffffff;
      width: 156px;
      height: 156px;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-right: 11px;
      img {
        width: 40px;
        height: 40px;
      }
      .num {
        font-size: 12px;
        margin: 4px 0;
        color: #969696;
      }
      .label {
        font-size: 14px;
        color: #646464;
      }
      &:last-child {
        margin-right: 0;
      }
    }
    .block3 {
      flex: 1;
      margin-right: 11px;
      &:last-child {
        margin-right: 0;
      }
      .box {
        flex: 1;
        border-radius: 4px;
        background-color: #ffffff;
        height: 74px;
        flex-direction: column;
        margin-bottom: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        .num {
          font-size: 12px;
          color: #969696;
          margin: 4px 0;
        }
        .label {
          font-size: 14px;
          color: #646464;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
  .table {
    width: 100%;
    .item {
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
      .label {
        display: flex;
        align-items: center;
        margin-bottom: 23px;
        position: relative;
        .titleLabel {
          color: #787878;
          font-size: 16px;
          margin-right: 77px;
        }
        .more {
          width: 100%;
          left: 200px;
          color: #d81212;
          font-size: 12px;
          position: absolute;
          cursor: pointer;
        }

        .line {
          width: 4px;
          height: 20px;
          background: #d81212;
          border-radius: 4px;
          margin-right: 10px;
        }
      }
      .useBox {
        img {
          margin-right: 8px;
          cursor: pointer;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
  .myTable {
    margin-bottom: 28px;
  }
}

.table-height {
  transition: max-height 0.2s ease-in-out;
  max-height: 1000px;
}
.table-height-0 {
  transition: max-height 0.2s ease-in-out;
  max-height: 0;
}

.handlerBoxCenter {
  display: flex;
  align-items: center;
  .iconDscp {
    color: #db1c1b;
    font-size: 12px;
  }
  .cursorPointer {
    margin-right: 4px;
  }
}

.signDetailDialogWithButton {
  height: 200px;
  width: 400px;
  box-sizing: border-box;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 0 20px;
  .authDscp {
    font-size: 14px;
    color: #646464;
    letter-spacing: 0;
    text-align: center;
    line-height: 20px;
    padding-top: 20px;
  }
  .withInput {
    width: 100%;
    text-align: left;
    .el-input__inner {
      width: 100%;
      height: 32px;
      line-height: 32px;
    }
  }
}
.signDialog {
  height: 200px;
  width: 400px;
  box-sizing: border-box;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 0 20px;
  .authDscp {
    font-size: 14px;
    color: #646464;
    letter-spacing: 0;
    text-align: center;
    line-height: 20px;
    padding-top: 20px;
  }
  .withInput {
    width: 100%;
    text-align: left;
    .el-input__inner {
      width: 100%;
      height: 32px;
      line-height: 32px;
    }
  }
}

/deep/ .el-table--small .el-table__cell {
  padding: 9px 0;
}

.el-table {
  color: #505050;
}
</style>
